"use client";

import { useStrictLocalization } from "@faire/web/common/localization";
import {
  IconButton,
  IconButtonVariants,
} from "@faire/web/slate-deprecated/IconButton";
import { Close as CloseIcon } from "@faire/web/slate/icons/foundation/Close";
import React from "react";
import styled from "styled-components";

export interface IToastCloseProps {
  closeToast: (() => void) | undefined;
  variant: IconButtonVariants;
}

export const ToastClose = ({ closeToast, variant }: IToastCloseProps) => {
  const { strictLocalize } = useStrictLocalization();

  return (
    <CloseButton
      aria-label={strictLocalize({
        id: "A7cklB",
        defaultMessage: "Close toast",
        description: { text: "Accessibility label for the toast close button" },
      })}
      onClick={closeToast}
      shape="square"
      size="small"
      variant={variant}
    >
      <CloseIcon />
    </CloseButton>
  );
};

const CloseButton = styled(IconButton)`
  flex-shrink: 0;
  margin-block-start: -16px; // Close button is bumped up in design so it visually lines up better
  margin-inline: 4px -16px;
  align-self: start;
`;
